<template>
	<div>
		<BudashiLedger
			v-if="rubber_process_type.name == '分出し作業'"
			:rubber_processes="rubber_processes"
			:query.sync="q"
			:rubber_process_type="rubber_process_type"
			@get-page="getPage($event)"
			@search-rubber-processes="searchRubberProcesses($event)"
		/>
			<!-- v-if="rubber_process_type.name == '押出しゴム管理票'" -->
		<!-- <Ledger
			v-if="rubber_process_type.name == 'B3000&B5000管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '接着糊管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '練生地依頼管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '裁断管理表管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '新練り管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '新練りゴム試験結果合否連絡票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '外注練り管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == 'ゴムシート管理票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/>
		<Ledger
			v-if="rubber_process_type.name == '分出しシート試験結果合否連絡票'"
			:rubber_processes="rubber_processes"
			:rubber_process_type="rubber_process_type"
		/> -->
	</div>
</template>

<script>
import axios from "axios"
import Qs from "qs"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"

export default {
	components: {
		BudashiLedger: () => import("./customer_orders/BudashiLedger.vue"),
	},
	data() {
		return {
			id: this.$route.params.id,
			rubber_process_type: {},
			rubber_processes: [],
			q: {
				sorts: "created_at desc",
			},
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchRubberProcesses(this.q, page, true)
	},

	methods: {
		fetchRubberProcesses(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })

			const url = `/erp/v1/rubber_process_types/${this.id}/rubber_processes`
			axios
				.get(url, { params, paramsSerializer, headers })
				.then((res) => {
					this.rubber_process_type = res.data.rubber_process_type
					this.rubber_processes = res.data.rubber_processes
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		searchOrderIndividualInfos(q) {
			this.q = q
			this.fetchRubberProcesses(q, 1, false)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		getPage(page) {
			this.fetchRubberProcesses(this.q, page, false)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: page },
			})
		},

		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}
</script>
